import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './counterSlice'
import userReducer from './user'
import callReducer from './caller'
import policyProductionReducer from './policyProduction'
import tasksReducer from './tasksSlice'
import leadsReducer from './leadsSlice'
import suesReducer from './suesSlice'
import filesReducer from './filesSlice'
import signsReducer from './signsSlice'
import subscribersReducer from './subscribersSlice'
import clientsReducer from './clientsSlice'

const store = configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    call: callReducer,
    policyProduction: policyProductionReducer,
    tasks: tasksReducer,
    leads: leadsReducer,
    sues: suesReducer,
    files: filesReducer,
    signs: signsReducer,
    subscribers: subscribersReducer,
    clientsSlice: clientsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
